import { SelectField } from "@/components/SelectField";
import { issuedBondKey, type IssuedBondChoice } from "@/lib/bondServicing";

// BRK-S412 — the Bond select the rider and claim dialogs share, over the
// insured's ISSUED bonds ("SB-xxxxx · {kind} · {obligee}"). A choice's value
// carries its submission too: both routes are addressed to the submission the
// bond came out of (`issuedBondKey`).

/** The bond list's state before there is anything to pick: loading, a failed
 *  read, or none issued. Null when the select can render. */
export function IssuedBondsNotice({
  bonds,
  bondsError,
  emptyText,
}: {
  bonds: readonly IssuedBondChoice[] | null;
  bondsError?: string | null;
  emptyText: string;
}) {
  if (bonds === null && bondsError) {
    return (
      <p role="alert" className="text-sm text-brk-danger">
        {bondsError}
      </p>
    );
  }
  if (bonds === null) {
    return (
      <p role="status" className="text-sm text-brk-dim">
        Loading the issued bonds…
      </p>
    );
  }
  if (bonds.length === 0) {
    return <p className="text-sm text-brk-dim">{emptyText}</p>;
  }
  return null;
}

export function IssuedBondField({
  options,
  value,
  onChange,
  error,
}: {
  options: readonly IssuedBondChoice[];
  value: string;
  onChange: (key: string) => void;
  error?: string;
}) {
  return (
    <SelectField
      label="Bond"
      required
      placeholder="Select a bond"
      value={value}
      options={options.map((b) => ({
        value: issuedBondKey(b),
        label: b.label,
      }))}
      onChange={(e) => onChange(e.target.value)}
      error={error}
    />
  );
}
